import React, {useMemo} from 'react';
import PerformanceUtils from 'services/PerformanceUtils';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import moment from 'moment-timezone';
import ValidatorUtils from 'services/ValidatorUtils';
import './style.scss';

const ClinicHours = props => {

  const rows = useMemo(() => {
    let rows = [];
    Object.keys(props.hours).forEach(index => {
      let name = PerformanceUtils.capitalizeFirstLetter(index).replace('_', ' ');
      rows.push({ index, name, values: (props.hours[index] || []) });
    });
    return rows;
  }, [props.hours]);

  function onChange(event, type, index, value) {
    if (!value || (ValidatorUtils.isInt(value) && value.length <= 4)) {
      let eventName = event.target.name;
      let openClose = 'open';
      if (eventName.indexOf('close') !== -1) openClose = 'close';
      let modified = PerformanceUtils.clone(props.hours);
      modified[type][index][openClose] = value;
      if (props.onChange) props.onChange(modified);
    }
  }

  return (
    <div className="clinic-info">
      <div className="clinic-schedule">
        <table>
          <tbody>
            <Header />
            {rows.map(row => (
              <Row key={row.name} row={row} onChange={onChange} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

const Header = () => {
  let days = moment.weekdays();
  days.push(days.shift());
  return (
    <tr>
      <th />
      {days.map(day => <th key={day}>{day}</th>)}
    </tr>
  );
};

const Row = ({ row, onChange }) => (
  <tr>
    <td className="name">{row.name}</td>
    {row.values.map((value, arrayIndex) => (
      <Value
        key={arrayIndex}
        {...value}
        onChange={(event) => onChange(event, row.index, arrayIndex, event.target.value)}
        name={row.index + arrayIndex}
      />
    ))}
  </tr>
);

const Value = ({ open, close, onChange, name }) => (
  <td>
    <DefaultTextField
      name={name + '-open'}
      value={open || ''}
      onChange={onChange}
      style={{ width: '40px' }}
    />
    <span>-</span>
    <DefaultTextField
      name={name + '-close'}
      value={close || ''}
      onChange={onChange}
      style={{ width: '40px' }}
    />
  </td>
);

ClinicHours.propTypes = {
  hours: PropTypes.object,
  onChange: PropTypes.func
};

export default ClinicHours;
